import {all} from '@redux-saga/core/effects';
import opportunitySaga from './opportunitySaga';
import quoteFormSaga from './quoteFormSaga';
import quoteActionSaga from './quoteActionSaga';
import ratingSaga from './ratingSaga';
import compensationSaga from './compensationSaga';
import quoteSearchSaga from './quoteSearchSaga';

export default function*() {
  yield all([quoteSearchSaga(), opportunitySaga(), quoteFormSaga(), quoteActionSaga(), ratingSaga(), compensationSaga()]);
}
